<template>
  <!-- 学生综合实训统计页面 -->
  <div class="xueShengZongHeShiXun">
    <div class="student_training_left" :style="'height:'+(height-90)+'px'">
      <div class="encourage_words">
        <p>{{famousQuotesData.content}}—{{famousQuotesData.author}}</p>
      </div>
      <div class="course_task_progress" v-if="false">
        <h2>课程任务进度<span>完成任务<i>{{taskProgressData.finishTaskNum}}个</i>/ 总任务<i>{{taskProgressData.totalTaskNum}}个</i></span></h2>
        <div class="course_task_progress_left">
          <el-progress :stroke-width="7" :percentage="taskProgressData.progress"></el-progress>
        </div>
        <div class="course_task_progress_right">
          <p><span><i>{{taskProgressData.sort}}</i>/{{taskProgressData.studentNum}}</span>班级排名</p>
          <img src="../../../../../../../static/images/study/statistics/ranking.png" alt="">
        </div>
      </div>
<!--      <div class="study_length">-->
<!--        <h2>-->
<!--          <span>累计学习时长</span>-->
<!--          <img src="../../../../../../../static/images/study/statistics/time.png" alt="">-->
<!--          <p>{{learnTime | filterTime}}</p>-->
<!--        </h2>-->
<!--      </div>-->
      <div class="post_statistics">
        <h2>分岗位正确率统计</h2>
        <ul v-if="postAccuracyStatisticsData.length>0">
          <li v-for="(item, i) in postAccuracyStatisticsData" :key="i">
            <el-progress type="circle" :percentage="item.rate?Math.ceil(item.rate*100) : 0" :color="postAccuracyColor[i]"></el-progress>
            <p>{{item.postName}}({{item.userName}})</p>
          </li>
        </ul>
        <div v-else class="no_data">
          <img src="../../../../../../../static/images/wujieguo.png" alt="">
          <p>暂无统计结果</p>
        </div>
      </div>
      <div class="group_comprehensive_strength">
        <h2>组队综合实力最新排行榜
          <span style="font-size: 13px;color: red">(算法规则:取小组正确率和完成任务数作为综合统计指标)</span>
        </h2>
        <ul v-if="groupComprehensiveStrength.length>0">
          <li>
            <div>排行</div>
            <div>小组名称</div>
            <div>实力值</div>
            <div>小组成员</div>
            <div>小组标语</div>
          </li>
          <li v-for="(item,i) in groupComprehensiveStrength" :key="i">
            <div>
              <img src="../../../../../../../static/images/study/statistics/first.png" alt="" v-if="i==0">
              <img src="../../../../../../../static/images/study/statistics/second.png" alt="" v-else-if="i==1">
              <img src="../../../../../../../static/images/study/statistics/thrid.png" alt="" v-else-if="i==2">
              <span v-else>{{i+1}}</span>
            </div>
            <div>{{item.teamName}}<span v-if="teamId==item.teamId" style="color:#FD785A">(我的)</span></div>
            <div>{{item.rate}}</div>
            <div>{{item.teamUserNames}}</div>
            <div>{{item.teamTitle}}</div>
          </li>
        </ul>
        <div v-else class="no_data">
          <img src="../../../../../../../static/images/wujieguo.png" alt="">
          <p>暂无统计结果</p>
        </div>
      </div>
      <div class="notes_and_discuss">
        <div class="notes_wrap">
          <h2>笔记</h2>
          <div class="note_details">
            <img src="../../../../../../../static/images/study/statistics/note.png" alt="">
            <div>
              <b>{{noteData.noteNum}}条</b>
              <p>公开笔记数</p>
            </div>
          </div>
        </div>
        <div class="discuss_wrap">
          <h2>讨论</h2>
          <ul>
            <li>
              <img src="../../../../../../../static/images/study/statistics/theme.png" alt="">
              <div>
                <b>{{discussData.themeNum}}条</b>
                <p>发表主题数</p>
              </div>
            </li>
            <li>
              <img src="../../../../../../../static/images/study/statistics/reply.png" alt="">
              <div>
                <b>{{discussData.replyNum}}条</b>
                <p>回复主题数</p>
              </div>
            </li>
            <li>
              <img src="../../../../../../../static/images/study/statistics/comment.png" alt="">
              <div>
                <b>{{discussData.commentNum}}条</b>
                <p>发表评论数</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="student_training_right" :style="'height:'+(height-90)+'px'" v-if="false">
      <h2>学习轨迹</h2>
      <el-timeline class="timeline_ul" v-if="activities.length>0">
        <el-timeline-item
          v-for="(activity, index) in activities"
          :key="index"
          :icon="activity.icon"
          :type="activity.type"
          :color="activity.color"
          :size="activity.size"
          :timestamp="activity.timestamp" placement="top">
          <div class="timeline_card">
            <p>{{activity.content}}</p>
            <!-- <i></i> -->
            <img v-if="activity.type=='1'" :src="picture"/>
            <img v-else-if="activity.type=='2'" :src="file"/>
            <img v-else-if="activity.type=='3'" :src="audio"/>
            <img v-else-if="activity.type=='4'" :src="video"/>
            <img v-else-if="activity.type=='5'" :src="zip"/>
            <img v-else-if="activity.type=='6'" :src="question"/>
            <img v-else-if="activity.type=='7'" :src="paper"/>
            <img v-else-if="activity.type=='8'" :src="file"/>
            <img v-else-if="activity.type=='9'" :src="file"/>
            <img v-else-if="activity.type=='10'" :src="file"/>
            <img v-else-if="activity.type=='11'" :src="file"/>
            <img v-else :src="file"/>
          </div>
        </el-timeline-item>
      </el-timeline>
      <div v-else class="no_data">
        <img src="../../../../../../../static/images/wujieguo.png" alt="">
        <p>暂无学习轨迹</p>
      </div>
    </div>
  </div>
</template>
<script>
  /**
   *  学生综合实训统计页面
   */

import cc from './tooltip.vue'
import qs from 'qs'
import * as api from '../../../../../../api/statisticsApi'
import * as api1 from "../../../../../../api/HNstatisticsApi"
export default {
  components: {cc},
  data() {
    return {
      courseId: this.$route.query.id,
      classId: this.$route.query.classId,
      teamId: '',
      userName: sessionStorage.getItem('loginName'),
      userId: sessionStorage.getItem('userId'),
      height: window.innerHeight,
      activities: [],//学习轨迹
      taskProgressData: {//课程进度
        finishTaskNum: 0,
        totalTaskNum: 0,
        progress: 0,
        resourceTypeDtos: [],
        sort: 0,
        studentNum: 0
      },
      noteData: {//笔记
        noteNum: ''
      },
      discussData: {//讨论
        themeNum: 0,
        replyNum: 0,
        commentNum: 0
      },
      postAccuracyStatisticsData: [],//分岗位正确统计率
      postAccuracyColor: ['#5397F7', '#FD785A', '#FECB61', '#34D3B0', '#FFB23C'],
      picture: '../../../../../../../static/images/study/sourceIcon/picture.png',
      video: '../../../../../../../static/images/study/sourceIcon/video.png',
      audio: '../../../../../../../static/images/study/sourceIcon/audio.png',
      zip: '../../../../../../../static/images/study/sourceIcon/zip.png',
      file: '../../../../../../../static/images/study/sourceIcon/file.png',
      paper: '../../../../../../../static/images/study/sourceIcon/paper.png',
      question: '../../../../../../../static/images/study/sourceIcon/question.png',
      famousQuotesData: {//心灵鸡汤
        content: '',
        author: ''
      },
      groupProgress: [],//排行榜
      groupComprehensiveStrength: [],//排行榜
      learnTime: '',//累计学习时长
    }
  },
  filters: {
    typeStatus(type) {
      switch (type) {
        case 1:
          return "图片";
        case 2:
          return "文档";
        case 3:
          return "音频";
        case 4:
          return "视频";
        case 5:
          return "zip";
        case 6:
          return "实操";
        case 7:
          return "测验";
        case 8:
          return "笔记";
        case 9:
          return "发布讨论";
        case 10:
          return "回复讨论";
        case 11:
          return "评论讨论";
        default:
          return "实操";
          break;
      }
    },
    filterTime(minutes){
      return (Math.floor(minutes/60) + " 小时 " + (minutes%60) + " 分钟" );
    }
  },
  mounted() {
    this.getTeam()//小组
  },
  methods: {
    init(){
      this.getFamousQuotes()//心灵鸡汤
      if(this.teamId){
        this.getPostData()//分岗位统计
        this.getCourseProgress()   //课程进度及小组进度 和  组队综合实力排行榜
        this.getNotesNum()//笔记
        this.getDiscussNum()//讨论
        // this.getLearnTimeStudent()//累计学习时长
      }
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    getFamousQuotes(){//心灵鸡汤
      api.getFamousQuotes().then(rs=>{
        if(rs.status==1){
          this.famousQuotesData = {
            content: rs.content,
            author: rs.author
          }
        }else{
          this.$messageError(rs)
        }
      })
    },
    getPostData(){//分岗位正确统计率
      let obj = {
        "classId": this.classId,
        "courseId": this.courseId,
        "teamId": this.teamId
      }
      api.getstudentPostDataTeam(qs.stringify(obj)).then(rs=>{
        if(rs.code==0){
          this.postAccuracyStatisticsData = rs.data
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getTeam(){//获取小组id
      let obj = {
        "classId": this.classId,
        "courseId": this.courseId,
      }
      api.getMyTeam(obj).then(rs=>{
        if(rs.code==0){
          rs.data.forEach(v=>{
            this.teamId = v.teamId
          })
        }else{
          this.$messageError(rs.msg)
        }
      }).then(()=>{
        this.init()
      })
    },
    //课程进度及小组进度
    getCourseProgress(){
      let that = this
      let obj = {
        "classId": this.classId,
        "courseId": this.courseId
      }
      api.getCourseProgress(qs.stringify(obj)).then(rs=>{
        if(rs.code==0){
          that.groupProgress = []
          rs.data.result.forEach(v=>{
            let obj = {
              classId: v.classId,
              courseId: v.courseId,
              progressWeight: Math.ceil(v.progressWeight*100),
              teamId: v.teamId,
              teamName: v.teamName,
              teamTitle: v.teamTitle
            }
            that.groupProgress.push(obj)
          })
          that.getGroupComprehensiveStrength()//组队综合实力排行榜
        }else{
          that.groupProgress = []
          that.$messageError(rs.msg)
        }
      })
    },
    getGroupComprehensiveStrength(){//排行榜
      let obj = {
        "classId": this.classId,
        "courseId": this.courseId,
      }
      api.getGroupComprehensiveStrength(qs.stringify(obj)).then(rs=>{
        if(rs.code==0){
          this.groupComprehensiveStrength = []
          this.groupComprehensiveStrength = rs.data;
          //
          [].forEach.call(this.groupComprehensiveStrength, item1 => {
            [].forEach.call(this.groupProgress, item2 => {
              if(item1.teamId == item2.teamId){
                item1.rate = Math.ceil(item1.rate*item2.progressWeight*100)
              }
            })
          })
          this.groupComprehensiveStrength = this.groupComprehensiveStrength.sort((a, b)=>{
            return b.rate - a.rate
          })
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getNotesNum(){//笔记
      api.getNotesNum(this.courseId,this.classId).then(rs=>{
        if(rs.code==0){
          this.noteData.noteNum = rs.data
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getDiscussNum(){//讨论
      api.getDiscussNum(this.courseId,this.classId).then(rs=>{
        if(rs.code==0){
          rs.data.forEach(v=>{
            if(v.type==0){
              this.discussData.themeNum = v.num
            }
            if(v.type==1){
              this.discussData.replyNum = v.num
            }
            if(v.type==2){
              this.discussData.commentNum = v.num
            }
          })
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getLearnTimeStudent(){
      api1.getLearnTimeStudent(this.courseId,this.classId,this.userId).then(rs=>{
        if(rs.code==0){
          this.learnTime = rs.data.learnTime
        }else{
          this.$messageError(rs.msg)
        }
      })
    }
  },
}
</script>
<style lang="scss" scoped>
  .xueShengZongHeShiXun{
    overflow-y: auto;
    .student_training_left{
      // width: calc(100% - 272px);
      width: calc(100% - 32px);
      margin: 16px;
      float: left;
      .encourage_words{
        width: 100%;
        height: 40px;
        background: url('../../../../../../../static/images/study/statistics/encourage-bg.png') no-repeat;
        background-size: 100% 100%;
        p{
          font-size:16px;
          line-height:40px;
          color:rgba(51,51,51,1);
          margin-left: 24px;
        }
      }
      .course_task_progress{
        height:120px;
        background:rgba(255,255,255,1);
        border-radius:4px;
        margin: 16px 0;
        position: relative;
        h2{
          font-size:16px;
          font-weight:600;
          color:rgba(51,51,51,1);
          padding: 16px 0 0 24px;
          span{
            font-size:12px;
            font-weight:400;
            color:#333333;
            margin-left: 16px;
            i{
              color: #5397F7;
              margin-left: 5px;
            }
          }
        }
        /deep/ .course_task_progress_left{
          width: 65%;
          margin-left: 24px;
          margin-top: 35px;
          .el-progress__text{
            font-size:12px !important;
            font-weight:400;
            color:rgba(83,151,247,1);
            margin-left: 20px;
          }
        }
        .course_task_progress_right{
          position: absolute;
          right: 33px;
          top: 28px;
          width:240px;
          height:64px;
          background:rgba(255,178,60,1);
          box-shadow:0px 3px 6px rgba(0,0,0,0.16);
          border-radius:4px;
          p{
            font-size:14px;
            font-weight:400;
            color:rgba(255,255,255,1);
            margin-left: 20px;
            margin-top: 10px;
            span{
              font-size: 24px;
              margin-right: 5px;
              i{
                font-size: 45px;
                font-style: normal;
                color: #fff;
              }
            }
          }
          img{
            width: 48px;
            height: 48px;
            position: absolute;
            right: 15px;
            top: 10px;
          }
        }
      }
      .study_length{
        height: 50px;
        background:rgba(255,255,255,1);
        border-radius: 4px;
        display: flex;
        margin-top: 16px;
        h2{
          height: 50px;
          display: flex;
          align-items: center;
          span{
            font-size:16px;
            font-weight:600;
            color:rgba(51,51,51,1);
            padding-left: 24px;
          }
          img{
            width: 24px;
            height: 24px;
            margin-left: 32px;
            margin-right: 16px;
          }
          p{
            font-size: 16px;
            font-weight:400;
            color:rgba(51,51,51,1);
            margin-left: 5px;
          }
        }
      }
      .post_statistics{
        height:252px;
        background:rgba(255,255,255,1);
        border-radius:4px;
        margin-top: 16px;
        h2{
          font-size:16px;
          font-weight:600;
          color:rgba(51,51,51,1);
          padding: 16px 0 0 24px;
        }
        ul{
          display: flex;
          width: 80%;
          justify-content: space-around;
          margin: 33px 10% 0;
          /deep/ li{
            width: 145px;
            text-align: center;
            p{
              margin-top: 18px;
              font-size:14px;
              line-height:19px;
              color:rgba(51,51,51,1);
            }
            .el-progress-circle{
              width: 115px !important;
              height: 115px !important;
            }
          }
        }
      }
      .group_comprehensive_strength{
        background:rgba(255,255,255,1);
        border-radius:4px;
        margin: 16px 0;
        padding-bottom: 24px;
        position: relative;
        h2{
          font-size:16px;
          font-weight:600;
          line-height:21px;
          color:rgba(51,51,51,1);
          padding: 16px 0 0 24px;
          margin-bottom: 16px;
          position: relative;
        }
        ul{
          margin: 32px 90px 0;
          border: 1px solid #F2F2F2;
          li{
            height: 40px;
            background: #EFF5FF;
            display: flex;
            align-items: center;
            &:nth-child(even){
              background: #fff;
            }
            div{
              font-size:14px;
              font-weight:400;
              color:rgba(102,102,102,1);
              text-align: center;
              &:nth-child(1){
                width: 100px;
                img{
                  width: 18px;
                  // height: 22px;
                }
                span{
                  font-size: 20px;
                  color: #333;
                  font-weight: 600;
                }
              }
              &:nth-child(2){width: 200px;}
              &:nth-child(3){width: 100px;}
              &:nth-child(4){flex: 1;}
              &:nth-child(5){width: 300px;}
            }
            &:nth-child(1){
              div{
                font-weight: 600;
              }
            }
          }
        }
      }
      .notes_and_discuss{
        height: 160px;
        margin: 16px 0;
        h2{
          font-size:16px;
          font-weight:600;
          color:rgba(51,51,51,1);
          padding: 16px 0 0 24px;
        }
        .notes_wrap{
          width:268px;
          height:160px;
          background:rgba(250,252,253,1);
          border-radius:4px;
          float: left;
          .note_details{
            width:220px;
            height:80px;
            background:rgba(255,255,255,1);
            box-shadow:0px 3px 6px rgba(0,0,0,0.16);
            border-radius:4px;
            display: flex;
            align-items: center;
            margin: 16px 0 0 24px;
            img{
              width: 56px;
              height: 56px;
              margin-left: 32px;
              margin-right: 16px;
            }
            div{
              b{
                font-size:24px;
                font-weight:400;
                color:rgba(51,51,51,1);
              }
              p{
                font-size:14px;
                color:rgba(153,153,153,1);
                margin-top: 10px;
              }
            }
          }
        }
        .discuss_wrap{
          width:calc(100% - 284px);
          height:160px;
          background:rgba(255,255,255,1);
          opacity:1;
          border-radius:4px;
          margin-left: 16px;
          float: right;
          ul{
            margin: 16px 16px 0 24px;
            display: flex;
            justify-content: space-between;
            li{
              width:220px;
              height:80px;
              background:rgba(255,255,255,1);
              box-shadow:0px 3px 6px rgba(0,0,0,0.16);
              border-radius:4px;
              display: flex;
              align-items: center;
              img{
                width: 56px;
                height: 56px;
                margin-left: 32px;
                margin-right: 16px;
              }
              div{
                b{
                  font-size:24px;
                  font-weight:400;
                  color:rgba(51,51,51,1);
                }
                p{
                  font-size:14px;
                  color:rgba(153,153,153,1);
                  margin-top: 10px;
                }
              }
            }
          }
        }
      }
      .test_wrap{
        background:rgba(255,255,255,1);
        border-radius:4px;
        h2{
          font-size:16px;
          font-weight:600;
          color:rgba(51,51,51,1);
          padding: 16px 0 0 24px;
        }
        .broken_line_diagram{
          position: relative;
          .test_left{
            width: calc(100% - 80px);
            margin-left: 24px;
            float: left;
            .data-empty {
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: rgba(255, 255, 255, .7);
              color: #888;
              font-size: 14px;
            }
            ul{
              display: flex;
              position: absolute;
              right: 20px;
              top:-20px;
              li{
                height: 33px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 40px;
                span{
                  width:70px;
                  font-size:14px;
                  color:rgba(51,51,51,1);
                  text-align: right;
                  margin-right: 12px;
                }
                i{
                  width:32px;
                  height:4px;
                }
                &:nth-child(1){
                  i{
                    background: #03D57C;
                  }
                }
                &:nth-child(2){
                  i{
                    background: #FF6464;
                  }
                }
                &:nth-child(3){
                  i{
                    background: #B95AFF;
                  }
                }
              }
            }
          }
          .test_right{
            width:241px;
            height:293px;
            border:1px solid rgba(235,235,235,1);
            border-radius:4px;
            float: right;
            margin-right: 24px;
            padding: 33px 25px;
            box-sizing: border-box;
            .test_right_top{
              width:192px;
              height:80px;
              background:rgba(52,211,176,1);
              border-radius:4px;
              padding: 15px 0 0 46px;
              box-sizing: border-box;
              p{
                color: #fff;
                &:first-child{
                  font-size: 24px;
                  position: relative;
                  &::after{
                    content: '';
                    width: 32px;
                    height: 1px;
                    position: absolute;
                    bottom: -3px;
                    left: 0;
                    background: #fff;
                  }
                }
                &:last-child{
                  font-size:14px;
                  color:rgba(255,255,255,1);
                  margin-top: 8px;
                }
              }
            }
            ul{
              margin-top: 30px;
              li{
                height: 33px;
                display: flex;
                align-items: center;
                justify-content: center;
                span{
                  width:70px;
                  font-size:14px;
                  color:rgba(51,51,51,1);
                  text-align: right;
                  margin-right: 12px;
                }
                i{
                  width:107px;
                  height:4px;
                }
                &:nth-child(1){
                  i{
                    background: #03D57C;
                  }
                }
                &:nth-child(2){
                  i{
                    background: #FF6464;
                  }
                }
                &:nth-child(3){
                  i{
                    background: #B95AFF;
                  }
                }
              }
            }
          }
          .test_bot{
            clear: both;
            display: flex;
            .test_bot_left{
              h2{
                font-size:16px;
                font-weight:600;
                color:rgba(51,51,51,1);
                padding: 16px 0 0 24px;
              }
              .test_bot_left_box{
                width:140px;
                height:80px;
                background:rgba(52,211,176,1);
                border-radius:4px;
                box-sizing: border-box;
                margin-left: 24px;
                margin-right: 20px;
                margin-top: 16px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;;
                p{
                  width: 90px;
                  text-align: left;
                  color: #fff;
                  &:first-child{
                    font-size: 24px;
                    position: relative;
                    &::after{
                      content: '';
                      width: 32px;
                      height: 1px;
                      position: absolute;
                      bottom: -3px;
                      left: 0;
                      background: #fff;
                    }
                  }
                  &:last-child{
                    font-size:12px;
                    color:rgba(255,255,255,1);
                    margin-top: 8px;
                  }
                }
              }
            }
            .test_bot_right{
              h2{
                font-size:16px;
                font-weight:600;
                color:rgba(51,51,51,1);
                padding: 16px 0 0 0;
              }
              ul{
                margin-top: 16px;
                display: flex;
                flex-wrap: wrap;
                li{
                  width:160px;
                  height:80px;
                  background:rgba(83,151,247,1);
                  border-radius:4px;
                  margin-bottom: 20px;
                  margin-right: 20px;
                  padding-left: 14px;
                  box-sizing: border-box;
                  position: relative;
                  p{
                    font-size: 12px;
                    color: #fff;
                    &:nth-child(1){
                      margin-top: 21px;
                      margin-bottom: 14px;
                    }
                    &:nth-child(2){
                      width: 100px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }
                    span{
                      font-size: 14px;
                    }
                  }
                  img{
                    width: 16px;
                    height: 16px;
                    position: absolute;
                    right: 12px;
                    bottom: 16px;
                    cursor: pointer;
                  }
                }
              }
            }
          }
        }
        .single_test_diagram{
          position: relative;
          height: 268px;
          .view_details{
            font-size: 12px;
            cursor: pointer;
            color: #5397F7;
            margin-left: 8px;
            position: absolute;
            right: 46px;
            top: -15px;
            i{
              display: inline-block;
              width: 8px;
              height: 8px;
              margin-left: 5px;
              background: url('../../../../../../../static/images/newLoginPage/icon2.png') no-repeat;
              background-size: 100%;
            }
          }
          div{
            text-align: center;
            p{
              &:first-child{
                font-size:16px;
                font-weight:400;
                color:rgba(51,51,51,1);
              }
              &:last-child{
                font-size:12px;
                font-weight:400;
                color:#999999;
                margin-top: 8px;
                span{
                  color: #F43D3D;
                }
              }
            }
          }
          ul{
            display: flex;
            width: 60%;
            justify-content: space-around;
            margin: 33px 20% 0;
            li{
              text-align: center;
              position: relative;
              p{
                font-size:14px;
                line-height:19px;
                color:rgba(51,51,51,1);
                margin-top: 14px;
              }
              .el-progress-circle{
                width: 115px !important;
                height: 115px !important;
              }
              span{
                position: absolute;
                left: 0;
                right: 0;
                top: 27px;
                background: #fff;
                width: 70px;
                height: 70px;
                line-height: 70px;
                margin: auto;
                font-size: 14px;
              }
            }
          }
        }
      }
    }
    .student_training_right{
      width:240px;
      background:rgba(255,255,255,1);
      border-radius:4px 0px 0px 4px;
      margin-top: 16px;
      float: right;
      overflow-y: auto;
      h2{
        font-size:16px;
        font-weight:600;
        color:rgba(51,51,51,1);
        padding: 16px 0 0 24px;
      }
      .timeline_ul{
        margin: 12px 16px 0 20px;
        .el-timeline-item__wrapper{
          padding-left: 16px;
        }
        .timeline_card{
          width:188px;
          height:36px;
          background:rgba(242,247,255,1);
          border-radius:4px;
          display: flex;
          align-items: center;
          cursor: pointer;
          position: relative;
          p{
            font-size:12px;
            font-weight:400;
            color:rgba(51,51,51,1);
            margin: 0 4px 0 12px;
          }
          i{
            width: 8px;
            height: 8px;
            background: url('../../../../../../../static/images/study/statistics/icon.png') no-repeat;
            background-size: 100% 100%;
          }
          img{
            width: 24px;
            height: 24px;
            position: absolute;
            right: 15px;
            top: 6px;
          }
          &:hover{
            // p{
            //   color: #5397F7;
            // }
            i{
              background: url('../../../../../../../static/images/study/statistics/icon1.png') no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
    }
    .no_data{
      text-align: center;
      img{
        width: 100px;
        margin-top: 50px;
      }
      p{
        margin-top: 15px;
        font-size: 14px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/statistics/student/comprehensiveTraining.vue